import 'react-app-polyfill/ie11';
import "./sass/index.scss";
import { renderToDOM } from "./App";
import util from './util/util';

if(!util.isIE11()){
    renderToDOM(document.getElementById("root"));
} else {
    
    var browserUpdate = require('browser-update');
    // console.log(browserUpdate)
    browserUpdate({required:{e:18,f:-3,o:-3,s:-1,c:-3},insecure:true,unsupported:true});
}

